import thumbnail from './scatterchart_thumb.svg';

export const metadata = {
  name: 'global.section.chartselection.scatterchart.title',
  thumbnail,
  icon: 'fa-chart-scatter-bubble',
  id: 'scatter',
  categories: ['categories.correlations'],
  description: 'global.section.chartselection.scatterchart.description',
  code: '',
  tutorial: '',
};
